import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Transaction } from '../../types';

export interface TransactionItemState {
  transactionId?: string;
  isLoading: boolean;
  transaction?: Transaction;
  chargebackRequestInProgress?: boolean;
  fraudRequestInProgress?: boolean;
}

const initialState: TransactionItemState = {
  isLoading: false,
};

export const transactionItemSlice = createSlice({
  name: 'transactionItem',
  initialState,
  reducers: {
    getTransaction: (state, action: PayloadAction<string>) => {
      state.transactionId = action.payload;
      state.isLoading = true;
    },
    getTransactionSuccess: (state, action: PayloadAction<Transaction>) => {
      state.transaction = action.payload;
      state.isLoading = false;
    },
    chargeback: (state) => { 
      state.chargebackRequestInProgress = true;
    },
    chargebackSuccess: (state) => { 
      state.chargebackRequestInProgress = false;
    },
    fraud: (state) => { 
      state.fraudRequestInProgress = true;
    },
    fraudSuccess: (state) => { 
      state.fraudRequestInProgress = false;
    },
    clearTransactionItemState: (state) => {
      state.isLoading = false;
      state.transaction = undefined;
      state.transactionId = undefined;
      state.chargebackRequestInProgress = undefined;
      state.fraudRequestInProgress = undefined;
    },
  },
});

export const {
  getTransaction,
  getTransactionSuccess,
  chargeback,
  chargebackSuccess,
  fraud,
  fraudSuccess,
  clearTransactionItemState,
} = transactionItemSlice.actions;

export default transactionItemSlice.reducer;
